import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ShipmentsList from "./all";
import ShipmentDetail from "./detail";

const PARENT_URL = "/cms/shipments";

const Index = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<ShipmentsList />} />
      <Route path={`/:shipmentId`} element={<ShipmentDetail />} />
      <Route path={`/:shipmentId/:mode`} element={<ShipmentDetail />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default Index;
